module.exports = __webpack_public_path__ + "img/jifen.fce8e2ee.png";